export function setInvalidateEmpty(e) {
  if (e.type === "invalid") {
    e.target.setCustomValidity("خطای فیلد خالی")
  } else {
    e.target.setCustomValidity("")
  }
}

export function setInvalidateLength(e, val) {
  if (e.target.value.length !== val) {
    e.target.setCustomValidity(`فیلد باید ${val} رقم باشد`)
  } else {
    e.target.setCustomValidity("")
  }
}

export const GlobalFormatNumber = (value) => {
  const num = Number(value?.toString().replace(/,/g, ""));
  return isNaN(num) ? value : new Intl.NumberFormat("fa-IR").format(num);
};

export function getApiUrlNotificationFiles(s3Path) {
  return (
    process.env.REACT_APP_API_URL +
    "/Documents/GetPhysicalFileS3Liara?path=" +  s3Path
  )
}

export function getApiUrlGasProjectFiles(fileName) {
  return (
    process.env.REACT_APP_API_URL +
    "/Users/GetPhysicalFileS3Liara?path=Upload/GasProjects/" +  fileName
  )
}

export function getApiUrlSupportFiles(fileName) {
  return (
    process.env.REACT_APP_API_URL +
    "/Users/GetPhysicalFileS3Liara?path=Upload/Supports/" + fileName + "&fileNumber=" + 0
  )
}

export function getApiUrlUserFiles(fileName) {
  return (
    process.env.REACT_APP_API_URL +
    "/Users/GetPhysicalFileS3Liara?path=Upload/UserFiles/" + fileName + "&fileNumber=" + 0
  )
}



export function getApiUrlGasProjectFilesWithFileNumber(fileName, fileNumber) {
  const checked = fileNumber.toString().substring(0, 4)
  switch (checked) {
    case "1401":
      return (
        process.env.REACT_APP_API_URL +
        "/Users/GetPhysicalFileS3?path=Upload/GasProjects/" + fileName
      )
    default:
      return (
        process.env.REACT_APP_API_URL +
        "/Users/GetPhysicalFileS3Liara?path=Upload/GasProjects/" + fileName + "&fileNumber=" + fileNumber
      )
  }
}


export function getUrlGasProjectFiles(fileName, fileNumber){
    return "Upload/GasProjects/" + fileName
}